import React, { FC, ReactElement } from 'react';
import { Chip, Avatar, Tooltip } from '@mui/material';
import { useStyles } from './styles';
import clsx from 'clsx';

export interface ChipItem {
  id: string;
  label: string;
  avatarUrl?: string | null;
  tooltip?: string;
}

interface ChipListProps {
  items: ChipItem[];
  onClick?: (item: ChipItem) => void;
  onDelete?: (item: ChipItem) => void;
  clickable?: boolean;
  defaultAvatar?: ReactElement;
  color?: 'primary' | 'secondary' | 'default';
  className?: string;
}

export const ChipList: FC<ChipListProps> = ({
  items,
  onClick,
  onDelete,
  clickable,
  defaultAvatar,
  color,
  className,
}) => {
  const classes = useStyles();

  const renderChip = (item: ChipItem) => {
    const avatar = item.avatarUrl ? (
      <Avatar
        alt={item.label}
        src={item.avatarUrl}
        imgProps={{
          onError: (e) => (e.target as Element).remove(),
        }}
      />
    ) : (
      defaultAvatar
    );

    return (
      <Chip
        key={item.id}
        label={item.label}
        classes={{
          root: classes.chipRoot,
          label: classes.chipLabel,
        }}
        onDelete={onDelete && (() => onDelete(item))}
        onClick={onClick && (() => onClick(item))}
        clickable={clickable}
        avatar={avatar}
        color={color}
      />
    );
  };

  return (
    <div className={clsx(classes.chipList, className)}>
      {items.map((item) => {
        if (item.tooltip) {
          return (
            <Tooltip key={item.id} title={item.tooltip}>
              {renderChip(item)}
            </Tooltip>
          );
        }
        return renderChip(item);
      })}
    </div>
  );
};
